var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelcomePageImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  fill: "currentColor",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  },
  viewBox: "0 0 838 1253"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "scale(2.00042)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h418.912v626H0z",
  style: {
    fill: "none"
  }
}), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h418.912v626H0z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(.044 .066)scale(.99979)"
}, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__b"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.9707 0 0 .8227 -492.4 -1782.93)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72c0-6.79-4.659-12.28-10.407-12.28H523.949c-5.747 0-10.406 5.49-10.406 12.28v369.71c0 6.78 4.659 12.28 10.406 12.28h398.187c5.748 0 10.407-5.5 10.407-12.28z",
  style: {
    fill: "#29484e"
  }
}), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72c0-6.79-4.659-12.28-10.407-12.28H523.949c-5.747 0-10.406 5.49-10.406 12.28v369.71c0 6.78 4.659 12.28 10.406 12.28h398.187c5.748 0 10.407-5.5 10.407-12.28z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__c)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.03019 0 0 1.2155 -36.698 -1336.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-1.614-3.6-3.602-3.6H582.181a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.597a3.607 3.607 0 0 0 3.602-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-1.614-3.6-3.602-3.6H582.181a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.597a3.607 3.607 0 0 0 3.602-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__d)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(590.66 3031.18)scale(.12596)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5,
  style: {
    fill: "#29484e"
  }
}), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__e"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__e)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 753.074,
  cy: 1119.74,
  rx: 107.626,
  ry: 120.532,
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.32946 0 0 .85195 -791.683 -541.568)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732.401 83.022s-60.948 4.94-60.948 146.475c0 46.087 27.31 83.503 60.948 83.503s60.948-37.416 60.948-83.503c0-141.535-60.948-146.475-60.948-146.475",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(-1.07253 0 0 -.78283 994.864 354.639)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M209.5 16.114c115.626 0 209.5 93.874 209.5 209.5s-93.874 209.5-209.5 209.5S0 341.24 0 225.614s93.874-209.5 209.5-209.5m0 15.878c-106.863 0-193.622 86.759-193.622 193.622S102.637 419.236 209.5 419.236s193.622-86.759 193.622-193.622S316.363 31.992 209.5 31.992",
  style: {
    fill: "#75959a"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.579-1.8-1.293-1.8h-91.778c-.713 0-1.292.81-1.292 1.8v14.38c0 .99.579 1.8 1.292 1.8h91.778c.714 0 1.293-.81 1.293-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.25337 0 0 .90101 -140.877 295.702)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.579 1.8-1.293 1.8h-91.778c-.713 0-1.292-.81-1.292-1.8v-14.38c0-.99.579-1.8 1.292-1.8h91.778c.714 0 1.293.81 1.293 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.25337 0 0 .90101 -140.877 295.702)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.371-1.8-.827-1.8h-92.71c-.456 0-.826.81-.826 1.8v14.38c0 .99.37 1.8.826 1.8h92.71c.456 0 .827-.81.827-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.02684 0 0 .4719 2.517 1626.35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.371 1.8-.827 1.8h-92.71c-.456 0-.826-.81-.826-1.8v-14.38c0-.99.37-1.8.826-1.8h92.71c.456 0 .827.81.827 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.02684 0 0 .4719 2.517 1626.35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.272-1.8-.608-1.8h-93.148c-.335 0-.607.81-.607 1.8v14.38c0 .99.272 1.8.607 1.8h93.148c.336 0 .608-.81.608-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.39706 0 0 .4719 -231.839 1643.75)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.272 1.8-.608 1.8h-93.148c-.335 0-.607-.81-.607-1.8v-14.38c0-.99.272-1.8.607-1.8h93.148c.336 0 .608.81.608 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.39706 0 0 .4719 -231.839 1643.75)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.50297 0 0 1.35134 435.887 -1568.73)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-3.675-3.6-8.202-3.6H586.781c-4.527 0-8.202 1.62-8.202 3.6v64.84c0 1.98 3.675 3.6 8.202 3.6h301.397c4.527 0 8.202-1.62 8.202-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-3.675-3.6-8.202-3.6H586.781c-4.527 0-8.202 1.62-8.202 3.6v64.84c0 1.98 3.675 3.6 8.202 3.6h301.397c4.527 0 8.202-1.62 8.202-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.69-1.8-1.54-1.8h-91.284c-.85 0-1.539.81-1.539 1.8v14.38c0 .99.689 1.8 1.539 1.8h91.284c.85 0 1.54-.81 1.54-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.7984 0 0 .3002 81.816 2128.968)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.69 1.8-1.54 1.8h-91.284c-.85 0-1.539-.81-1.539-1.8v-14.38c0-.99.689-1.8 1.539-1.8h91.284c.85 0 1.54.81 1.54 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.7984 0 0 .3002 81.816 2128.968)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.026-1.8-.057-1.8h-94.25c-.031 0-.056.81-.056 1.8v14.38c0 .99.025 1.8.056 1.8h94.25c.031 0 .057-.81.057-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(3.1847 0 0 .04403 -1428.75 2922.678)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.026 1.8-.057 1.8h-94.25c-.031 0-.056-.81-.056-1.8v-14.38c0-.99.025-1.8.056-1.8h94.25c.031 0 .057.81.057 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.1847 0 0 .04403 -1428.75 2922.678)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-1.38-1.8-3.079-1.8h-88.206c-1.699 0-3.078.81-3.078 1.8v14.38c0 .99 1.379 1.8 3.078 1.8h88.206c1.699 0 3.079-.81 3.079-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.3992 0 0 .3002 334.518 2150.741)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-1.38 1.8-3.079 1.8h-88.206c-1.699 0-3.078-.81-3.078-1.8v-14.38c0-.99 1.379-1.8 3.078-1.8h88.206c1.699 0 3.079.81 3.079 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.3992 0 0 .3002 334.518 2150.741)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.026-1.8-.057-1.8h-94.25c-.031 0-.056.81-.056 1.8v14.38c0 .99.025 1.8.056 1.8h94.25c.031 0 .057-.81.057-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(3.1847 0 0 .04403 -1428.75 2944.451)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.026 1.8-.057 1.8h-94.25c-.031 0-.056-.81-.056-1.8v-14.38c0-.99.025-1.8.056-1.8h94.25c.031 0 .057.81.057 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.1847 0 0 .04403 -1428.75 2944.451)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(2.8856 0 0 .60894 -1205.55 1123.86)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(2.8856 0 0 .60894 -1205.55 1123.86)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.665-1.8-1.484-1.8h-91.395c-.819 0-1.484.81-1.484 1.8v14.38c0 .99.665 1.8 1.484 1.8h91.395c.819 0 1.484-.81 1.484-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.10429 0 0 .40027 -111.815 1809.79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.665 1.8-1.484 1.8h-91.395c-.819 0-1.484-.81-1.484-1.8v-14.38c0-.99.665-1.8 1.484-1.8h91.395c.819 0 1.484.81 1.484 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.10429 0 0 .40027 -111.815 1809.79)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.50297 0 0 1.35134 268.337 -1568.73)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-3.675-3.6-8.202-3.6H586.781c-4.527 0-8.202 1.62-8.202 3.6v64.84c0 1.98 3.675 3.6 8.202 3.6h301.397c4.527 0 8.202-1.62 8.202-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-3.675-3.6-8.202-3.6H586.781c-4.527 0-8.202 1.62-8.202 3.6v64.84c0 1.98 3.675 3.6 8.202 3.6h301.397c4.527 0 8.202-1.62 8.202-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(2.8856 0 0 .60894 -1205.55 1123.86)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(2.8856 0 0 .60894 -1205.55 1123.86)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.665-1.8-1.484-1.8h-91.395c-.819 0-1.484.81-1.484 1.8v14.38c0 .99.665 1.8 1.484 1.8h91.395c.819 0 1.484-.81 1.484-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.10429 0 0 .40027 -111.815 1809.79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.665 1.8-1.484 1.8h-91.395c-.819 0-1.484-.81-1.484-1.8v-14.38c0-.99.665-1.8 1.484-1.8h91.395c.819 0 1.484.81 1.484 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.10429 0 0 .40027 -111.815 1809.79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.909-1.8-2.029-1.8h-90.305c-1.12 0-2.029.81-2.029 1.8v14.38c0 .99.909 1.8 2.029 1.8h90.305c1.12 0 2.029-.81 2.029-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.60574 0 0 .3002 203.776 2128.97)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.909 1.8-2.029 1.8h-90.305c-1.12 0-2.029-.81-2.029-1.8v-14.38c0-.99.909-1.8 2.029-1.8h90.305c1.12 0 2.029.81 2.029 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.60574 0 0 .3002 203.776 2128.97)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.348-1.8-.776-1.8h-92.812c-.428 0-.775.81-.775 1.8v14.38c0 .99.347 1.8.775 1.8h92.812c.428 0 .776-.81.776-1.8z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1215.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.348 1.8-.776 1.8h-92.812c-.428 0-.775-.81-.775-1.8v-14.38c0-.99.347-1.8.775-1.8h92.812c.428 0 .776.81.776 1.8m-.579 0c0-.26-.088-.46-.197-.46h-92.812c-.108 0-.196.2-.196.46v14.38c0 .25.088.45.196.45h92.812c.109 0 .197-.2.197-.45z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1215.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.377-1.8-.841-1.8h-92.681c-.464 0-.841.81-.841 1.8v14.38c0 .99.377 1.8.841 1.8h92.681c.464 0 .841-.81.841-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.22617 0 0 .25187 -182.116 2286.61)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.377 1.8-.841 1.8h-92.681c-.464 0-.841-.81-.841-1.8v-14.38c0-.99.377-1.8.841-1.8h92.681c.464 0 .841.81.841 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.22617 0 0 .25187 -182.116 2286.61)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.348-1.8-.776-1.8h-92.812c-.428 0-.775.81-.775 1.8v14.38c0 .99.347 1.8.775 1.8h92.812c.428 0 .776-.81.776-1.8z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1230.44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.348 1.8-.776 1.8h-92.812c-.428 0-.775-.81-.775-1.8v-14.38c0-.99.347-1.8.775-1.8h92.812c.428 0 .776.81.776 1.8m-.579 0c0-.26-.088-.46-.197-.46h-92.812c-.108 0-.196.2-.196.46v14.38c0 .25.088.45.196.45h92.812c.109 0 .197-.2.197-.45z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1230.44)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.377-1.8-.841-1.8h-92.681c-.464 0-.841.81-.841 1.8v14.38c0 .99.377 1.8.841 1.8h92.681c.464 0 .841-.81.841-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.22617 0 0 .25187 -182.116 2301.85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.377 1.8-.841 1.8h-92.681c-.464 0-.841-.81-.841-1.8v-14.38c0-.99.377-1.8.841-1.8h92.681c.464 0 .841.81.841 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.22617 0 0 .25187 -182.116 2301.85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.348-1.8-.776-1.8h-92.812c-.428 0-.775.81-.775 1.8v14.38c0 .99.347 1.8.775 1.8h92.812c.428 0 .776-.81.776-1.8z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1245.68)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.348 1.8-.776 1.8h-92.812c-.428 0-.775-.81-.775-1.8v-14.38c0-.99.347-1.8.775-1.8h92.812c.428 0 .776.81.776 1.8m-.579 0c0-.26-.088-.46-.197-.46h-92.812c-.108 0-.196.2-.196.46v14.38c0 .25.088.45.196.45h92.812c.109 0 .197-.2.197-.45z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.1847 0 0 .60346 -1428.75 1245.68)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1045.6 220.134h726.621v31.742H1045.6z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(1.02808 0 0 .72221 -544.435 2699.17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.474-1.8-1.058-1.8h-92.247c-.584 0-1.058.81-1.058 1.8v14.38c0 .99.474 1.8 1.058 1.8h92.247c.584 0 1.058-.81 1.058-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.97474 0 0 .25187 -22.959 2301.85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.474 1.8-1.058 1.8h-92.247c-.584 0-1.058-.81-1.058-1.8v-14.38c0-.99.474-1.8 1.058-1.8h92.247c.584 0 1.058.81 1.058 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.97474 0 0 .25187 -22.959 2301.85)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.332-1.8-.741-1.8h-92.881c-.409 0-.741.81-.741 1.8v14.38c0 .99.332 1.8.741 1.8h92.881c.409 0 .741-.81.741-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.39153 0 0 .25187 -286.792 2317.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.332 1.8-.741 1.8h-92.881c-.409 0-.741-.81-.741-1.8v-14.38c0-.99.332-1.8.741-1.8h92.881c.409 0 .741.81.741 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.39153 0 0 .25187 -286.792 2317.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1324.63 712.132.81.812-5.15 5.151 5.15 5.15-.81.812-5.15-5.151-5.15 5.151-.82-.812 5.15-5.15-5.15-5.151.82-.812 5.15 5.151z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.86462 0 0 .3797 -265.999 2811.93)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1324.63 712.132.81.812-5.15 5.151 5.15 5.15-.81.812-5.15-5.151-5.15 5.151-.82-.812 5.15-5.15-5.15-5.151.82-.812 5.15 5.151z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.86462 0 0 .3797 -265.999 2796.68)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1324.63 712.132.81.812-5.15 5.151 5.15 5.15-.81.812-5.15-5.151-5.15 5.151-.82-.812 5.15-5.15-5.15-5.151.82-.812 5.15 5.151z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.86462 0 0 .3797 -265.999 2781.44)"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.49183 0 0 1.42298 -1629.95 -2140.38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(3.49183 0 0 1.42298 -1629.95 -2140.38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.622-1.8-1.387-1.8h-91.589c-.766 0-1.387.81-1.387 1.8v14.38c0 .99.621 1.8 1.387 1.8h91.589c.765 0 1.387-.81 1.387-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.63008 0 0 .5736 290.611 564.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.622 1.8-1.387 1.8h-91.589c-.766 0-1.387-.81-1.387-1.8v-14.38c0-.99.621-1.8 1.387-1.8h91.589c.765 0 1.387.81 1.387 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.63008 0 0 .5736 290.611 564.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72v369.71c0 6.78-4.659 12.28-10.407 12.28H523.949c-5.747 0-10.406-5.5-10.406-12.28v-369.71c0-6.79 4.659-12.28 10.406-12.28h398.187c5.748 0 10.407 5.49 10.407 12.28m-397.366 351.94c0 1.2.404 2.35 1.123 3.2s1.694 1.32 2.712 1.32h368.062c1.017 0 1.992-.47 2.712-1.32.719-.85 1.123-2 1.123-3.2v-334.17c0-1.2-.404-2.35-1.123-3.2-.72-.85-1.695-1.33-2.712-1.33H539.012c-1.018 0-1.993.48-2.712 1.33s-1.123 2-1.123 3.2z",
  style: {
    fill: "#75959a"
  }
}))))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.9705 0 0 .82253 -492.253 -1782.49)"
}, _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M513.543 2274.44h419v200.599h-419z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72c0-6.79-4.659-12.28-10.407-12.28H523.949c-5.747 0-10.406 5.49-10.406 12.28v369.71c0 6.78 4.659 12.28 10.406 12.28h398.187c5.748 0 10.407-5.5 10.407-12.28z",
  style: {
    fill: "#29484e"
  }
}), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72c0-6.79-4.659-12.28-10.407-12.28H523.949c-5.747 0-10.406 5.49-10.406 12.28v369.71c0 6.78 4.659 12.28 10.406 12.28h398.187c5.748 0 10.407-5.5 10.407-12.28z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__i)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.03019 0 0 1.2155 -36.698 -1336.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-1.614-3.6-3.602-3.6H582.181a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.597a3.607 3.607 0 0 0 3.602-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-1.614-3.6-3.602-3.6H582.181a3.607 3.607 0 0 0-3.602 3.6v64.84c0 1.98 1.614 3.6 3.602 3.6h310.597a3.607 3.607 0 0 0 3.602-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__j)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(590.66 3031.18)scale(.12596)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5,
  style: {
    fill: "#29484e"
  }
}), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__k"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__k)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 753.074,
  cy: 1119.74,
  rx: 107.626,
  ry: 120.532,
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.32946 0 0 .85195 -791.683 -541.568)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M732.401 83.022s-60.948 4.94-60.948 146.475c0 46.087 27.31 83.503 60.948 83.503s60.948-37.416 60.948-83.503c0-141.535-60.948-146.475-60.948-146.475",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(-1.07253 0 0 -.78283 994.864 354.639)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M209.5 16.114c115.626 0 209.5 93.874 209.5 209.5s-93.874 209.5-209.5 209.5S0 341.24 0 225.614s93.874-209.5 209.5-209.5m0 15.878c-106.863 0-193.622 86.759-193.622 193.622S102.637 419.236 209.5 419.236s193.622-86.759 193.622-193.622S316.363 31.992 209.5 31.992",
  style: {
    fill: "#75959a"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.579-1.8-1.293-1.8h-91.778c-.713 0-1.292.81-1.292 1.8v14.38c0 .99.579 1.8 1.292 1.8h91.778c.714 0 1.293-.81 1.293-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.25337 0 0 .90101 -140.877 295.702)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.579 1.8-1.293 1.8h-91.778c-.713 0-1.292-.81-1.292-1.8v-14.38c0-.99.579-1.8 1.292-1.8h91.778c.714 0 1.293.81 1.293 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.25337 0 0 .90101 -140.877 295.702)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.371-1.8-.827-1.8h-92.71c-.456 0-.826.81-.826 1.8v14.38c0 .99.37 1.8.826 1.8h92.71c.456 0 .827-.81.827-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.02684 0 0 .4719 2.517 1626.35)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.371 1.8-.827 1.8h-92.71c-.456 0-.826-.81-.826-1.8v-14.38c0-.99.37-1.8.826-1.8h92.71c.456 0 .827.81.827 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.02684 0 0 .4719 2.517 1626.35)"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(3.49183 0 0 1.42298 -1629.95 -2140.38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(3.49183 0 0 1.42298 -1629.95 -2140.38)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.622-1.8-1.387-1.8h-91.589c-.766 0-1.387.81-1.387 1.8v14.38c0 .99.621 1.8 1.387 1.8h91.589c.765 0 1.387-.81 1.387-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.63008 0 0 .5736 290.611 564.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.622 1.8-1.387 1.8h-91.589c-.766 0-1.387-.81-1.387-1.8v-14.38c0-.99.621-1.8 1.387-1.8h91.589c.765 0 1.387.81 1.387 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.63008 0 0 .5736 290.611 564.2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M932.543 2286.72v369.71c0 6.78-4.659 12.28-10.407 12.28H523.949c-5.747 0-10.406-5.5-10.406-12.28v-369.71c0-6.79 4.659-12.28 10.406-12.28h398.187c5.748 0 10.407 5.49 10.407 12.28m-397.366 351.94c0 1.2.404 2.35 1.123 3.2s1.694 1.32 2.712 1.32h368.062c1.017 0 1.992-.47 2.712-1.32.719-.85 1.123-2 1.123-3.2v-334.17c0-1.2-.404-2.35-1.123-3.2-.72-.85-1.695-1.33-2.712-1.33H539.012c-1.018 0-1.993.48-2.712 1.33s-1.123 2-1.123 3.2z",
  style: {
    fill: "#75959a"
  }
})))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.48813 0 0 .80739 -231.833 -2218.18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-2.669-3.6-5.958-3.6H584.536c-3.288 0-5.957 1.62-5.957 3.6v64.84c0 1.98 2.669 3.6 5.957 3.6h305.886c3.289 0 5.958-1.62 5.958-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__l"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-2.669-3.6-5.958-3.6H584.536c-3.288 0-5.957 1.62-5.957 3.6v64.84c0 1.98 2.669 3.6 5.957 3.6h305.886c3.289 0 5.958-1.62 5.958-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(2.8856 0 0 .88832 -1205.55 251.291)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(2.8856 0 0 .88832 -1205.55 251.291)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.856-1.8-1.911-1.8h-90.542c-1.054 0-1.91.81-1.91 1.8v14.38c0 .99.856 1.8 1.91 1.8h90.542c1.055 0 1.911-.81 1.911-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.85776 0 0 .55105 44.242 1352.08)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.856 1.8-1.911 1.8h-90.542c-1.054 0-1.91-.81-1.91-1.8v-14.38c0-.99.856-1.8 1.91-1.8h90.542c1.055 0 1.911.81 1.911 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.85776 0 0 .55105 44.242 1352.08)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.436-1.8-.972-1.8h-92.42c-.536 0-.971.81-.971 1.8v14.38c0 .99.435 1.8.971 1.8h92.42c.536 0 .972-.81.972-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.26502 0 0 .41329 -213.559 1791.98)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.436 1.8-.972 1.8h-92.42c-.536 0-.971-.81-.971-1.8v-14.38c0-.99.435-1.8.971-1.8h92.42c.536 0 .972.81.972 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.26502 0 0 .41329 -213.559 1791.98)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1110.86 520.064c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.93c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.93c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.93c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.68 0c-.16 0-.3-.321-.3-.718v-2.564c0-.396.14-.718.3-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.7 0c-.18 0-.31-.321-.31-.718v-2.564c0-.396.13-.718.31-.718h15.93c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.68 0c-.17 0-.3-.321-.3-.718v-2.564c0-.396.13-.718.3-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.3-.321-.3-.718v-2.564c0-.396.13-.718.3-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718H1313c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.94c.17 0 .31.322.31.718v2.564c0 .397-.14.718-.31.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.94c.17 0 .3.322.3.718v2.564c0 .397-.13.718-.3.718zm20.69 0c-.17 0-.31-.321-.31-.718v-2.564c0-.396.14-.718.31-.718h15.94c.17 0 .3.322.3.718v2.564c0 .397-.13.718-.3.718z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.13478 0 0 .29448 -673.003 2928.34)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.48813 0 0 .80739 -69.227 -2218.18)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-2.669-3.6-5.958-3.6H584.536c-3.288 0-5.957 1.62-5.957 3.6v64.84c0 1.98 2.669 3.6 5.957 3.6h305.886c3.289 0 5.958-1.62 5.958-3.6z",
  style: {
    fill: "#336468"
  }
}), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__m"
}, /*#__PURE__*/React.createElement("path", {
  d: "M896.38 3027.18c0-1.98-2.669-3.6-5.958-3.6H584.536c-3.288 0-5.957 1.62-5.957 3.6v64.84c0 1.98 2.669 3.6 5.957 3.6h305.886c3.289 0 5.958-1.62 5.958-3.6z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__m)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(2.8856 0 0 .83832 -1205.55 408.262)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M618.287 3119.72H728.42v19.514H618.287z",
  style: {
    fill: "#4c767c"
  },
  transform: "matrix(2.8856 0 0 .83832 -1205.55 408.262)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.514-1.8-1.147-1.8h-92.07c-.633 0-1.146.81-1.146 1.8v14.38c0 .99.513 1.8 1.146 1.8h92.07c.633 0 1.147-.81 1.147-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.42955 0 0 .55105 -317.71 1352.57)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.514 1.8-1.147 1.8h-92.07c-.633 0-1.146-.81-1.146-1.8v-14.38c0-.99.513-1.8 1.146-1.8h92.07c.633 0 1.147.81 1.147 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.42955 0 0 .55105 -317.71 1352.57)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.723-1.8-1.612-1.8h-91.139c-.89 0-1.612.81-1.612 1.8v14.38c0 .99.722 1.8 1.612 1.8h91.139c.889 0 1.612-.81 1.612-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(.76247 0 0 .41329 191.584 1791.98)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.723 1.8-1.612 1.8h-91.139c-.89 0-1.612-.81-1.612-1.8v-14.38c0-.99.722-1.8 1.612-1.8h91.139c.889 0 1.612.81 1.612 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.76247 0 0 .41329 191.584 1791.98)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06c0-.99-.391-1.8-.872-1.8h-92.62c-.481 0-.871.81-.871 1.8v14.38c0 .99.39 1.8.871 1.8h92.62c.481 0 .872-.81.872-1.8z",
  style: {
    fill: "#29484e"
  },
  transform: "matrix(1.41041 0 0 .41329 -216.151 1810.41)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M727.38 3040.06v14.38c0 .99-.391 1.8-.872 1.8h-92.62c-.481 0-.871-.81-.871-1.8v-14.38c0-.99.39-1.8.871-1.8h92.62c.481 0 .872.81.872 1.8",
  style: {
    fill: "#75959a"
  },
  transform: "matrix(1.41041 0 0 .41329 -216.151 1810.41)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 209.5,
  cy: 225.614,
  r: 209.5,
  style: {
    fill: "#75959a"
  },
  transform: "matrix(.17172 0 0 .10382 587.221 3045.98)"
}))), /*#__PURE__*/React.createElement("ellipse", {
  cx: 355.2,
  cy: 601.394,
  rx: 34.2,
  ry: 9.12,
  style: {
    fillOpacity: 0.12
  },
  transform: "matrix(-1.45526 0 0 .99979 596.299 .066)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.43538 0 0 .43538 398.1 -120.457)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M346.955 599.731s-4.363 0-4.363 3.66c0 .822 1.955 1.49 4.363 1.49s4.363-.668 4.363-1.49c0-3.66-4.363-3.66-4.363-3.66",
  style: {
    fill: "#a76547"
  },
  transform: "matrix(-.04312 -1.65658 -4.8513 .12629 2273.82 2154.16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M346.955 599.731s-4.363 0-4.363 2.661c0 1.374 1.955 2.489 4.363 2.489s4.363-1.115 4.363-2.489c0-2.661-4.363-2.661-4.363-2.661",
  style: {
    fill: "#a76547"
  },
  transform: "matrix(1.62564 0 0 -2.85006 -1345.93 3372.46)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2007.24 276.823)scale(1.14819)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1144.51 842.993c1.01 14.153 26.14 354.787 26.14 354.787-2 2.34-3.85 2.14-5.59.19-1.54-21.83-53.69-166.76-76.38-228.969l-18.47 231.819c-1.94 2.46-3.84 2.2-5.71 0 0 0-45.22-343.264-45.22-353.78 0-4.729 25.13-8.886 52.87-10.741 33.95-2.269 71.81-1.094 72.36 6.694",
  style: {
    fill: "#d57a00"
  }
}), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__n"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1144.51 842.993c1.01 14.153 26.14 354.787 26.14 354.787-2 2.34-3.85 2.14-5.59.19-1.54-21.83-53.69-166.76-76.38-228.969l-18.47 231.819c-1.94 2.46-3.84 2.2-5.71 0 0 0-45.22-343.264-45.22-353.78 0-4.729 25.13-8.886 52.87-10.741 33.95-2.269 71.81-1.094 72.36 6.694"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__n)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1067.18 1204.85-25.29-331.387s27.78-3.889 40.01-9.207c12.24-5.318 37.41-15.461 52.32-11.209s-11.92-18.837-19.03-17.776c-7.1 1.061-116.97 5.181-116.97 5.181l53.63 360.598z",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "M1086.91 942.98s82.64 225.94 78.15 254.99l-76.38-228.969z",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2007.24 276.823)scale(1.14819)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-782.477 999.575s-37.59 5.425-61.735 34.065c0 0 22.307 170.74 6.283 217.13-16.025 46.39 93.554-11.38 125.48 2.7 31.926 14.09 29.738-10.31 21.134-29.78s19.073-160.15-4.984-203.35c-22.712-12.48-70.222-25.721-86.178-20.765",
  style: {
    fill: "#f48f00"
  }
}), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__o"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-782.477 999.575s-37.59 5.425-61.735 34.065c0 0 22.307 170.74 6.283 217.13-16.025 46.39 93.554-11.38 125.48 2.7 31.926 14.09 29.738-10.31 21.134-29.78s19.073-160.15-4.984-203.35c-22.712-12.48-70.222-25.721-86.178-20.765"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__o)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1030.95 695.848c-.11-.324-.18-.489-.18-.489q.12.115.18.489",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2007.24 276.823)scale(1.14819)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1031.91 833.31c-3.83 16.359-6.51 23.079-2.11 25.762 6.56 4.012 52.1-5.089 52.1-5.089s-70.53 37.79-72.06 16.248c-1.49-21.015 22.82-164.483 21.11-174.383 1.57 4.388 12.8 38.019 8.6 88.507-.64 7.645-1.43 14.53-2.31 20.729l103.13-29.1s7.48 5.391 5.36 11.041-13.55 4.506-13.55 4.506c-6.32 6.145-80 34.147-100.27 41.779",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2007.24 276.823)scale(1.14819)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1097.03 658.98s2.08 117.516 14.94 129.049c12.85 11.533 20.21-14.364 20.21-14.364l-27.81-116.103s-8.24-3.967-7.34 1.418",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2007.24 276.823)scale(1.14819)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M573.312 351.448h-14.089v10.207a7.044 7.044 0 0 0 7.044 7.044h.001a7.044 7.044 0 0 0 7.044-7.044z",
  style: {
    fill: "#d57a00"
  },
  transform: "translate(-2093.37 276.823)scale(2.29638)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-30 -765.587 929.975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-767.346 1007.94s8.748-38.989 22.174-57.874c0 0-7.647-28.234-40.229-20.079-61.179 15.313-29.171 50.687-29.171 50.687z",
  style: {
    fill: "#a76547"
  }
}), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__p"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-767.346 1007.94s8.748-38.989 22.174-57.874c0 0-7.647-28.234-40.229-20.079-61.179 15.313-29.171 50.687-29.171 50.687z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__p)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-767.346 1007.94s8.748-38.989 22.174-57.874c0 0-7.647-28.234-40.229-20.079-61.179 15.313-29.171 50.687-29.171 50.687z",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-5.096 -2.942)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-2.40507 0 0 2.40507 96.543 246.407)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M349.24 302.948s1.424 17.363-2.304 23.695c0 0 9.615 2.316 15.1-1.45 3.727-2.558 3.644-12.208 5.159-11.704 0 0-4.132-8.444-.398-13.983 3.733-5.54-13.497 5.881-17.557 3.442",
  style: {
    fill: "#e8c9a6"
  }
}), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__q"
}, /*#__PURE__*/React.createElement("path", {
  d: "M349.24 302.948s1.424 17.363-2.304 23.695c0 0 9.615 2.316 15.1-1.45 3.727-2.558 3.644-12.208 5.159-11.704 0 0-4.132-8.444-.398-13.983 3.733-5.54-13.497 5.881-17.557 3.442"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__q)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1062.84 635.724 23.39 1.327s-3.34-5.614-.65-7.591c0 0 5.21 6.31 7.61 6.021l4.98 30.464s24.07-12.081 24.07-17.733-13.67-30.714-13.67-30.714l-30.16-12.063-20.37 18.492z",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "matrix(-.4774 0 0 .4774 874.728 12.647)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1.16165 -.67068 .80391 -1.39241 525.806 917.784)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M343.23 273.171s-10.511 0-10.511 15.204c0 4.84 4.71 8.769 10.511 8.769s10.511-3.929 10.511-8.769c0-15.204-10.511-15.204-10.511-15.204",
  style: {
    fill: "#e8c9a6"
  }
}), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__r"
}, /*#__PURE__*/React.createElement("path", {
  d: "M343.23 273.171s-10.511 0-10.511 15.204c0 4.84 4.71 8.769 10.511 8.769s10.511-3.929 10.511-8.769c0-15.204-10.511-15.204-10.511-15.204"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__r)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1084.16 571.509s-13.28 45.714 24.93 43.076c0 0-11.55 17.136-35.63 4.804-24.07-12.332 5.51-47.817 10.7-47.88",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "matrix(.30823 -.14846 -.17796 -.25715 112.12 596.044)"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M-877.023 1138.37s16.92 68.39 32.811 83.22 140.807-36.24 148.301-49.96-3.278-14.6-3.278-14.6l-122.321 16.49s1.943-48.81 1.047-60.02c-.896-11.22-56.56 24.87-56.56 24.87",
  style: {
    fill: "#e8c9a6"
  }
}), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__s"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-877.023 1138.37s16.92 68.39 32.811 83.22 140.807-36.24 148.301-49.96-3.278-14.6-3.278-14.6l-122.321 16.49s1.943-48.81 1.047-60.02c-.896-11.22-56.56 24.87-56.56 24.87"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__s)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1006.75 823.272c-2.45 1.684-5.09 2.898-6.824 1.99-4.054-2.116-49.277-139.202-4.238-154.405 0 0-24.52 81.084 17.232 147.101 23.06 5.335 87.44-21.359 103.6-28.308-7.53-5.914-10.85-18.521-10.85-18.521 22.61-15.801 35.7 4.079 36.36 10.387.56 5.442-5.94 11.361-15.19 11.361-7.31 14.6-104.99 37.449-112.14 36.641-2.12-.241-5.17-2.956-7.95-6.246",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2007.24 276.823)scale(1.14819)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1.95 -2.429)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-787.791 1003.55s-61.832 22.57-70.132 37.47-29.109 68.85-14.045 110.74c30.03-3.01 52.808-16.86 53.499-22.15s-1.118-51.73-5.018-57.61c-3.901-5.88 35.696-68.45 35.696-68.45",
  style: {
    fill: "#f48f00"
  }
}), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__t"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-787.791 1003.55s-61.832 22.57-70.132 37.47-29.109 68.85-14.045 110.74c30.03-3.01 52.808-16.86 53.499-22.15s-1.118-51.73-5.018-57.61c-3.901-5.88 35.696-68.45 35.696-68.45"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__t)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1006.75 823.272c-2.45 1.684-5.09 2.898-6.824 1.99-4.054-2.116-49.277-139.202-4.238-154.405 0 0-24.52 81.084 17.232 147.101 23.06 5.335 87.44-21.359 103.6-28.308-7.53-5.914-10.85-18.521-10.85-18.521 22.61-15.801 35.7 4.079 36.36 10.387.56 5.442-5.94 11.361-15.19 11.361-7.31 14.6-104.99 37.449-112.14 36.641-2.12-.241-5.17-2.956-7.95-6.246",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "translate(-2005.29 279.252)scale(1.14819)"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M-671.693 1104.91s3.023 28.09.073 48.88c-2.32 16.34-9.615 22.89-20.16 27.52-22.409 9.83-23.973-60.64-25.579-69.97-1.606-9.34 45.666-6.43 45.666-6.43",
  style: {
    fill: "#e8c9a6"
  },
  transform: "matrix(1 0 0 .99618 0 4.216)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-740.999 1003.65s40.756 9.7 55.197 23.04c14.44 13.34 18.54 91.43 17.425 103.51 0 0-42.055 7.29-45.81-1.62-3.755-8.9-26.812-124.93-26.812-124.93",
  style: {
    fill: "#f48f00"
  },
  transform: "translate(-1.95 -2.429)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-678.977 1006.89s-21.252 104.62-21.252 149.46c0 13.82 9.523 25.05 21.252 25.05s21.251-11.23 21.251-25.05c0-44.84-21.251-149.46-21.251-149.46",
  style: {
    fill: "#e8c9a6"
  },
  transform: "matrix(1.27413 -.3414 .28965 1.08098 -169.49 -328.206)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588.812 328.76q-.01.021-.025.021zm-3.226-12.711c-.75.176-1.057-.747-1.844-1.106-.998-.456-1.939-.503-2.602-1.652-1.377-2.384-1.037-5.163.76-6.2 1.519-.877 3.597-.229 5.035 1.434q.042.042.082.087c.733.801 1.415 2.146 1.465 2.831.158 2.175 4.747 11.058 6.071 12.351l-5.741 4.966c.227-.48-1.958-8.984-3.226-12.711",
  style: {
    fill: "#e8c9a6"
  },
  transform: "translate(-2093.37 276.823)scale(2.29638)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-739.977 986.395s6.312-5.26 5.577-1.458c-.734 3.802-3.6 2.306-3.054 7.09s-2.523-5.632-2.523-5.632",
  style: {
    fill: "#e8c9a6"
  },
  transform: "translate(-4.502 2.67)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-764.933 1006.18s-17.381-92.395 28.864-86.549c0 0-6.641-29.975-39.223-21.82-61.179 15.314-42.122 100.563-42.122 100.563z",
  style: {
    fill: "#a76547"
  }
}), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
  id: "welcome-page-image_svg__u"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-764.933 1006.18s-17.381-92.395 28.864-86.549c0 0-6.641-29.975-39.223-21.82-61.179 15.314-42.122 100.563-42.122 100.563z"
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#welcome-page-image_svg__u)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-764.933 1006.18s-16.706-94.921 29.54-89.075c0 0-6.641-29.975-39.224-21.82-61.178 15.313-42.797 103.089-42.797 103.089z",
  style: {
    fill: "#29484e",
    fillOpacity: 0.1
  },
  transform: "matrix(.97705 -.21303 .26122 1.19807 -299.204 -359.013)"
}))))));
export default SvgWelcomePageImage;